import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHEstablecimientoUpd = async (credentials, data) => {
  const body = {
    service: "RNHEstablecimientoUpd",
    params: {
      rnhEstablecimientoId: data?.id,
      rnhEstablecimientoCod: data?.cod,
      rnhTipoComponenteCod: data?.type || '',
      rnhEstablecimientoNombre: data?.name,
      rnhNivelId: data?.nivelId,
      rnhAreaId: data?.areaId,
      rnhEstablecimientoCabecera: data?.cabecera,
      rnhEstablecimientoCalle: data?.calle,
      rnhEstablecimientoNumero: data?.numero,
      rnhEstablecimientoPiso: data?.piso,
      rnhEstablecimientoCPA: data?.cpa,
      rnhEstablecimientoUnidad: data?.unidad,
      localidadId: data?.localidadId,
      rnhEstablecimientoLatitud: data?.lat,
      rnhEstablecimientoLongitud: data?.lng,
      rnhEstablecimientoAdmiteRotativos: data?.admiteRotativos || null,
      rnhEstablecimientoAdmiteGuardias: data?.admiteGuardias || null,
      rnhEstablecimientoVersion: data?.version,
    },
  };

  return respuestaDe(await axiosPost(body, credentials));
};
